import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a2361034&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style1 from "./detail.vue?vue&type=style&index=1&id=a2361034&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2361034",
  null
  
)

export default component.exports